import "./ColourPicker.scss";

import React, { useCallback, useState } from "react";
import { SketchPicker } from "react-color";

const DEFAULT_COLOUR = "rgba(255, 255, 255, 1)";

interface ColourPickerProps {
	value: string;
	defaultValue: string;
	onChange: (val: any) => void;
}

const rgbToString = (rgb: any) =>
	rgb ? `rgba(${rgb?.r}, ${rgb?.g}, ${rgb?.b}, ${rgb.a})` : "";

const ColourPicker: React.FC<ColourPickerProps> = (props) => {
	const [displayPicker, setDisplayPicker] = useState(false);
	const colourValue = props.value
		? props.value
		: props.defaultValue || DEFAULT_COLOUR;

	const togglePicker = useCallback(
		() => setDisplayPicker(!displayPicker),
		[displayPicker, setDisplayPicker],
	);
	const closePIcker = useCallback(
		() => setDisplayPicker(false),
		[setDisplayPicker],
	);

	const handleChange = useCallback(
		(newVal) => {
			if (props.onChange) {
				props.onChange(rgbToString(newVal.rgb));
			}
		},
		[props],
	);

	return (
		<div className={"ColourPicker"}>
			<div
				className={"ColourPicker__toggle-container"}
				onClick={togglePicker}
				role={"button"}
				tabIndex={0}
			>
				<div
					className={"ColourPicker__swatch"}
					style={{
						background: colourValue,
					}}
				/>
				<p className={"ColourPicker__label"}>{colourValue}</p>
			</div>
			{displayPicker && (
				<>
					<div
						className={"ColourPicker__cover"}
						onClick={closePIcker}
						role={"button"}
						tabIndex={0}
					/>
					<SketchPicker
						{...props}
						onChange={handleChange}
						className={"ColourPicker__picker"}
						color={colourValue}
					/>
				</>
			)}
		</div>
	);
};

export default ColourPicker;
